import useDeleteMeal from '../../hooks/data/meals/useDeleteMeal';
import useDeleteExercise from '../../hooks/data/exercises/useDeleteExercise';
import ModalHeader from '../components/ModalHeader';
import ActionStatusText from '../../components/ui/ActionStatusText';
import ErrorMessage from '../../components/ui/ErrorMessage';
import { useModalEntry } from '../../context/ModalEntryContext';
import { useModalEntryType, useModalNavigation, useModalPayload } from '../../context/ModalControllerContext';
import { useDiarySection } from '../../context/DiarySectionsContext';

const ModalDeleteConfirm = ({ currentDay }) => {
    const { selectedEntryId } = useModalEntry();
    const { entryType } = useModalEntryType();

    const isExercise = entryType === 'exercise';

    const payload = useModalPayload();

    const { close, closeWithDelay } = useModalNavigation();

    const { closeSection } = useDiarySection();

    const {
        deleteMeal,
        isDeleting: isDeletingMeal,
        isSuccess: isSuccessMeal,
        isError: isErrorMeal,
        error: errorMeal
    } = useDeleteMeal(currentDay);

    const {
        deleteExercise,
        isDeleting: isDeletingExercise,
        isSuccess: isSuccessExercise,
        isError: isErrorExercise,
        error: errorExercise
    } = useDeleteExercise(currentDay);

    const handleDelete = async () => {
        try {
            if (!isExercise && !selectedEntryId) {
                console.warn('No meal ID provided for deletion');
                return;
            }

            if (payload?.slotIndex) closeSection(payload?.slotIndex);

            const deleteAction = isExercise ? () => deleteExercise() : () => deleteMeal(selectedEntryId);
            await deleteAction();

            closeWithDelay();
        } catch (err) {
            console.error('Deletion failed:', err);
        }
    };

    const entryKindName = isExercise ? 'motionen' : 'måltiden';

    const isDeleting = isDeletingMeal || isDeletingExercise;
    const isSuccess = isSuccessMeal || isSuccessExercise;
    const isError = isErrorMeal || isErrorExercise;
    const error = errorMeal || errorExercise;
    const disableButtons = isDeleting || isSuccess;

    return (
        <>
            <ModalHeader
                showBack={false}
                onClose={close}
                title={isExercise ? 'Radera motion' : 'Radera måltid'}
                disableButtons={disableButtons}
            />

            <div className="modal-body delete-confirm">
                {!isError ? (
                    <div className="content-text">
                        <p>Är du säker på att du vill radera {entryKindName}?</p>
                    </div>
                ) : (
                    <ErrorMessage message={error?.message || 'Något gick fel vid borttagningen.'} />
                )}
            </div>

            <div className="modal-footer delete-confirm">
                <button onClick={handleDelete} className="btn-red" disabled={disableButtons}>
                    <ActionStatusText
                        processingLabel="Raderar"
                        successLabel={`${isExercise ? 'Motionen' : 'Måltiden'} raderades`}
                        defaultLabel="Radera"
                        isProcessing={isDeleting}
                        isCompleted={isSuccess}
                    />
                </button>

                <button onClick={close} className="marked-border-btn" disabled={disableButtons}>
                    Avbryt
                </button>
            </div>
        </>
    );
};

export default ModalDeleteConfirm;
